import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminDevis from "@/pages/admin/AdminDevis";
import AdminVehicules from "@/pages/admin/AdminVehicules";
import AdminUtilisateurs from "@/pages/admin/AdminUtilisateurs";
import AdminCalendrierMariages from "@/pages/admin/AdminCalendrierMariages";
import AdminFactures from "@/pages/admin/AdminFactures";
import AdminClients from "@/pages/admin/AdminClients";
import AdminImportPDF from "@/pages/admin/AdminImportPDF";
import AdminParametres from "@/pages/admin/AdminParametres";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminStats from "@/pages/admin/AdminStats";

export default function AdminApp() {
  const { isAuthenticated, loading, user } = useAuth();
  if (loading) return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (!isAuthenticated) return <AdminLogin />;
  
  const isAdmin = user?.role === "admin";
  
  return (
    <AdminLayout>
      <Routes>
        <Route index element={<Navigate to="/admin/devis" replace />} />
        <Route path="devis" element={<AdminDevis />} />
        {isAdmin && (
          <>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="factures" element={<AdminFactures />} />
            <Route path="reservations" element={<AdminCalendrierMariages />} />
            <Route path="clients" element={<AdminClients />} />
            <Route path="contacts" element={<AdminContacts />} />
            <Route path="stats" element={<AdminStats />} />
            <Route path="import-pdf" element={<AdminImportPDF />} />
            <Route path="parametres" element={<AdminParametres />} />
            <Route path="vehicules" element={<AdminVehicules />} />
            <Route path="utilisateurs" element={<AdminUtilisateurs />} />
          </>
        )}
        <Route path="*" element={<Navigate to="/admin/devis" replace />} />
      </Routes>
    </AdminLayout>
  );
}
